export const AccionesDiagnocatEnum = Object.freeze({
    SELECCIONAR_ESTUDIO: 1,
    CAMBIAR_PADECIMIENTO: 2,
    RECARGAR_ESTUDIOS: 3,
    SELECCIONAR_PADECIMIENTO: 4,
    AGREGAR_ODONTOGRAMA: 5,
    DESELECCIONAR_PADECIMIENTO: 6,
    SELECCIONAR_DIAGNOSTICO: 7,
    ABRIR_MODAL: 8,
    ELIMINAR_DIENTE: 9,
    CERRAR_MODAL: 10,
});